module.exports = __webpack_public_path__ + "img/FlexCWHLogo.19274cc6.svg";